export default __webpack_public_path__ + "static/media/trainingrequired_segment.8e77ff65.svg";